module.exports = __webpack_public_path__ + "img/zbjs.e3bc55c0.png";